import { RATIOS_OPTIMIZAR } from "../Texts/DropdownData";

export const DictionaryRatios = (value: string) => {
    const translate = RATIOS_OPTIMIZAR.find(item => item.key === value);
    return translate?.text
}